import type { Metadata } from 'next';
import PaymentMethodForm from '@/Component/Admin/AdminPaymentMethod/PaymentMethodForm';

export const metadata: Metadata = {
  title: 'Add Payment Method | Connector Club',
  description: 'Create a new payment method with dynamic fields',
};

export default function CreatePaymentMethodPage() {
  return (
    <PaymentMethodForm />
  );
}
